import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import cookie from "react-cookies";
import { setUser, clearUser } from "./features/user/userSlice";
import { getBalance } from "./features/transaction/transactionSlice";
import { getOrganizationByUuid } from "./features/organization/organizationSlice";
import { decodeToken, getRedirectByRole } from "./utils/authHeader";
import { ROLE } from "./constants/constants";
import LoadingComponent from "./components/common/LoadingComponent";

const ProtectedRoute = ({ children, allowedRole }) => {
  const dispatch = useDispatch();

  const [authState, setAuthState] = useState({
    checking: true,
    authenticated: false,
    role: null,
  });

  useEffect(() => {
    const initAuth = async () => {
      const token = cookie.load("token");

      if (!token) {
        dispatch(clearUser());
        return setAuthState({
          checking: false,
          authenticated: false,
          role: null,
        });
      }

      const decoded = decodeToken(token);

      if (!decoded?.uuid || !decoded?.role) {
        dispatch(clearUser());
        return setAuthState({
          checking: false,
          authenticated: false,
          role: null,
        });
      }

      dispatch(setUser(decoded));

      if (decoded.role === ROLE.USER) {
        dispatch(getBalance());
        dispatch(getOrganizationByUuid(decoded?.org));
      }

      setAuthState({
        checking: false,
        authenticated: true,
        role: decoded.role,
      });
    };

    initAuth();
  }, [dispatch]);

  if (authState.checking) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <LoadingComponent loading={true} size={15} />
      </div>
    );
  }

  if (!authState.authenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (allowedRole && authState.role !== allowedRole) {
    return <Navigate to={getRedirectByRole(authState.role)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
